import { useEffect, type DependencyList } from 'react';
import { useBreadcrumbContext, type BreadcrumbState } from '../contexts/breadcrumb-context';

/**
 * Sets the navbar breadcrumb for the current page.
 * Uses a factory function + explicit deps to avoid infinite loops from
 * unstable callback references (e.g. `() => navigate(-1)`).
 *
 * @param factory - Called when deps change; return null to show the logo.
 * @param deps    - Dependency array (same rules as useEffect).
 */
export function useBreadcrumb(
  factory: () => BreadcrumbState | null,
  deps: DependencyList
): void {
  const { setBreadcrumb } = useBreadcrumbContext();
  useEffect(() => {
    setBreadcrumb(factory());
    return () => setBreadcrumb(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
